import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import './SaveVariantModal.css';
import './reassignModal.css';
import DeleteIcon from '@mui/icons-material/Delete';
import ShareIcon from '@mui/icons-material/Share';
import { MultiDropdown } from "../../../components/common/MultiDropdown";
import { Box, CircularProgress, Autocomplete, TextField } from "@mui/material";
import ButtonComponent from "../../../components/common/button/Button";
import Modal from "../../../components/common/modal/Modal";
import { deleteSaveVarientEndpoint, getAllUsersDetailsEndpoint, getSaveVarientEndpoint, shareSaveVarientEndpoint } from "../../../common/endpoints";
import { getSaveVarientSlice } from "../../../redux/actions/getSaveVarientSlice";
import { deleteSaveVarientSlice } from "../../../redux/actions/deleteSaveVarientSlice";
import { shareSaveVarientSlice } from "../../../redux/actions/shareSaveVarientSlice";
import { getAllUsersDetailsSlice } from "../../../redux/actions/getAllUsersDetailsSlice";

export const ShowVariantViewModal = ({ openShowVariantModal, handleCloseShowVariantModal, data, tableType, onClickSelectVariant }) => {
    const dispatch = useDispatch();
    const userEmail = localStorage.getItem("userEmail");
    const [variantsData, setVariantsData] = useState([])
    const [shareVariantData, setShareVariantData] = useState([]);

    const onCloseVariantModal = () => {
        handleCloseShowVariantModal();
    }
    const onClickCancel = () => {
        handleCloseShowVariantModal();
    }
    const getVariantsData = async () => {
        try {
            const responseGetVariants = await dispatch(getSaveVarientSlice({
                dynamicEndpoint: `${getSaveVarientEndpoint}/${userEmail}`,
            }));
            if (responseGetVariants?.meta?.requestStatus === 'fulfilled') {
                setVariantsData(responseGetVariants?.payload?.variants)
            } else {
                console.error('Failed to fetch data:', responseGetVariants?.error);
                toast.error(responseGetVariants?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error(error, {
                autoClose: 2000,
            });
        }
    }


    useEffect(() => {
        if (openShowVariantModal === true) {
            getVariantsData();
        }
    }, [openShowVariantModal])

    const deleteSelectedVariant = async (id) => {

        try {
            const responseDeleteVariant = await dispatch(deleteSaveVarientSlice({
                dynamicEndpoint: `${deleteSaveVarientEndpoint}/${id}`
            }));
            if (responseDeleteVariant?.meta?.requestStatus === 'fulfilled') {
                toast.success(responseDeleteVariant?.payload, {
                    autoClose: 2000,
                });
                getVariantsData();
            } else {
                console.error('Failed to fetch data:', responseDeleteVariant?.error);
                toast.error(responseDeleteVariant?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error(error, {
                autoClose: 2000,
            });
        }
    }
    const onClickSelectButton = (item) => {
        onClickSelectVariant(item);
        onClickCancel();
    }

    return (
        <>
            <Modal
                className="showVariantModal_cls"
                open={openShowVariantModal}
                handleClose={onCloseVariantModal}
                title="Variants Catalog"
                fullWidth={true}
                action={
                    <ShowVariantFooter
                        onClickCancel={onClickCancel}
                    />
                }
                content={
                    <ShowVariantContent
                        variantsData={variantsData}
                        tableType={tableType}
                        deleteSelectedVariant={deleteSelectedVariant}
                        onClickSelectButton={onClickSelectButton}
                        onClickCancel={onClickCancel}
                    />
                }
            />
        </>
    )
}

const ShowVariantFooter = ({ onClickCancel }) => {
    return (
        <div className='finalLTupdatedfooter-btn-wrapper'>
            <ButtonComponent
                label="Close"
                type="primary"
                maxWidth="80px"
                onClick={onClickCancel}
            />
        </div>
    );
};
const ShowVariantContent = ({ variantsData, deleteSelectedVariant, onClickSelectButton }) => {
    const dispatch = useDispatch();
    const [isShareClicked, setIsShareClicked] = useState(false);
    const [selectedShareID, setSelectedShareID] = useState("");
    const [role, setRole] = useState(null);
    const [usersByRole, setUsersByRole] = useState({});
    const [users, setUsers] = useState([]);
    const [shareResponse, setShareResponse] = useState("");
    const userEmail = localStorage.getItem("userEmail");

    const DeleteVariantSlice = useSelector((state) => state.DeleteVariantSlice);
    const GetShareUserSlice = useSelector((state) => state.GetShareUserSlice);
    const PostShareVariantSlice = useSelector((state) => state.PostShareVariantSlice);
    const GetVariantsListSlice = useSelector((state) => state.GetVariantsListSlice);
    const isLoading =
        DeleteVariantSlice?.loading ||
        GetShareUserSlice?.loading ||
        PostShareVariantSlice?.loading ||
        GetVariantsListSlice?.loading;

    const [formData, setFormData] = useState({
        selectedUsers: [],
    })



    const handleClickBack = () => {
        setIsShareClicked(false);
        setShareResponse("");
        setFormData({ selectedUsers: [] })
    }
    const deleteVariant = (id) => {
        deleteSelectedVariant(id)
    }
    const shareVariant = (id) => {
        setIsShareClicked(true);
        setSelectedShareID(id)
    }

    const handleSelectedItemsChange = (name, newSelectedItems) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: newSelectedItems,
        }));
    }

    const handleShareVariantAPI = async () => {
        const reqBodyData = []
        formData?.selectedUsers?.map((item) => {
            reqBodyData.push({ name: item.title, email: item.value })
        });

        const reqBody = {
            "userEmail": userEmail,
            "tableType": `FORECAST`,
            "sharedUsers": reqBodyData,
            "userVariantMapSeqId": selectedShareID
        }
        try {
            const responseShareVariant = await dispatch(shareSaveVarientSlice({
                dynamicEndpoint: `${shareSaveVarientEndpoint}`,
                data: reqBody,
            }));
            if (responseShareVariant?.meta?.requestStatus === 'fulfilled') {
                setShareResponse(responseShareVariant?.payload);
            } else {
                console.error('Failed to fetch data:', responseShareVariant?.error);
                toast.error(responseShareVariant?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error(error, {
                autoClose: 2000,
            });
        }
    }
    const handleClickSelect = (item) => {
        onClickSelectButton(item);
    }
    const loggedInRole = localStorage.getItem("userRole"); // AppAdmin, SupplierAdmin, SupplierPlanner, etc.

    const allRoles = [
        "App Admin",
        "Regional Planner",
        "Regional Viewer",
        "Global Planner",
        "Global Viewer",
        "Supplier Admin",
        "Supplier Planner",
    ];

    let filteredRoles = allRoles;

    if (loggedInRole === "App Admin") {
        // Hide supplier roles
        filteredRoles = allRoles.filter(
            role => !["Supplier Admin", "Supplier Planner"].includes(role)
        );
    } else if (
        loggedInRole === "Supplier Admin" ||
        loggedInRole === "Supplier Planner"
    ) {
        // Show only supplier roles
        filteredRoles = ["Supplier Admin", "Supplier Planner"];
    } const roleMapping = {
        "App Admin": "AppAdmin",
        "Regional Planner": "Planner",
        "Global Planner": "GlobalPlanner",
        "Global Viewer": "GlobalViewer",
        "Regional Viewer": "Viewer",
        "Supplier Admin": "SupplierAdmin",
        "Supplier Planner": "SupplierPlanner"
    };
    const getUniqueValues = (data = []) => {
        return [...new Set(
            data
                ?.filter(item => item?.email)
                ?.map(item => item.email)
        )].map(email => ({
            label: email,
            value: email,
            title: email,
        }));
    };
    const handleRoleChange = async (event, newRole) => {
        setRole(newRole);
        setFormData({ selectedUsers: [] });

        if (!newRole) return;

        const apiRole = roleMapping[newRole];

        if (usersByRole[apiRole]) {
            setUsers(usersByRole[apiRole]);

        }

        try {
            const response = await dispatch(
                getAllUsersDetailsSlice({
                    dynamicEndpoint: `${getAllUsersDetailsEndpoint}?shareVariantRole=${encodeURIComponent(apiRole)}`,
                })
            );

            if (response?.meta?.requestStatus === "fulfilled") {
                const users = response.payload || [];
                setUsersByRole((prev) => ({
                    ...prev,
                    [apiRole]: users,
                }));

                setUsers(users);
            } else {
                toast.error(response?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong", {
                autoClose: 2000,
            });
        }
    };
    const filteredUsers = users?.filter((user) => user.email !== userEmail);

    return (
        isLoading ?
            <Box style={{ textAlign: 'center', height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CircularProgress color="inherit" style={{ width: '20px', height: '20px', textAlign: 'center', marginRight: 30 }} />
            </Box>
            :
            <div style={{ overflowX: "auto" }}>{
                isShareClicked ?
                    <div>
                        {shareResponse === "" ?
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={{ display: 'flex', gap: 40 }}>
                                    <div className="parameter-dropdowns" style={{ width: 400, display: 'flex' }}>
                                        <span>Select Role</span>
                                        <Autocomplete
                                            disableClearable={true}
                                            options={filteredRoles}
                                            value={role}
                                            onChange={handleRoleChange}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select Role"
                                                    variant="outlined"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        sx: {
                                                            width: '100%',
                                                            backgroundColor: "#fff",
                                                            overflow: "hidden",
                                                            whiteSpace: "nowrap",
                                                            textOverflow: "ellipsis",
                                                        }
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className="parameter-dropdowns" style={{ width: 400, display: 'flex' }}>
                                        <span>Select Users</span>
                                        <MultiDropdown
                                            id="selectedUsers"
                                            name="selectedUsers"
                                            options={getUniqueValues(filteredUsers) || []}
                                            selectedItemsData={formData?.selectedUsers || []}
                                            onChangeItems={handleSelectedItemsChange}
                                            disabled={filteredUsers?.length === 0}
                                        />
                                    </div>
                                </div>
                                <div className='finalLTupdatedfooter-warning-btn-wrapper'>
                                    <ButtonComponent
                                        label="Back"
                                        type="primary"
                                        maxWidth="80px"
                                        onClick={handleClickBack}
                                    />
                                    <ButtonComponent
                                        label="Share"
                                        type="secondary"
                                        maxWidth="80px"
                                        onClick={handleShareVariantAPI}
                                        disabled={formData?.selectedUsers?.length === 0}
                                    />
                                </div>
                            </div>
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <p style={{ whiteSpace: 'pre-line' }}> {shareResponse}</p>
                                <div className='finalLTupdatedfooter-warning-btn-wrapper'>
                                    <ButtonComponent
                                        label="Back"
                                        type="primary"
                                        maxWidth="80px"
                                        onClick={handleClickBack}
                                    />
                                </div>
                            </div>
                        }
                    </div> :
                    variantsData?.length > 0 ? (
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr style={{ backgroundColor: "#f5f5f5" }}>
                                    <th style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "200px" }}>Variant Name</th>
                                    <th style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "400px" }}>Variant Description</th>
                                    <th style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "150px" }}>Created On</th>
                                    <th style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "150px" }}>Modified On</th>
                                    <th style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", width: "200px" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {variantsData.map((item) => (
                                    <tr key={item?.userVariantMapSeqId}>
                                        <td style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "200px" }}>{item?.variantName}</td>
                                        <td style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "400px" }}>{item?.variantDescription}</td>
                                        <td style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "150px" }}>{item?.createdOn}</td>
                                        <td style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "150px" }}>{item?.modifiedOn}</td>
                                        <td style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "center", width: "200px" }}>
                                            <div style={{ display: 'flex', justifyContent: 'center', gap: 10 }}>
                                                <span><ButtonComponent
                                                    label="Select"
                                                    type="secondary"
                                                    maxWidth="100px"
                                                    onClick={() => handleClickSelect(item)}
                                                /></span>
                                                <span style={{ cursor: "pointer", marginRight: "12px" }} onClick={() => shareVariant(item?.userVariantMapSeqId)}><ShareIcon /></span>
                                                <span style={{ cursor: "pointer" }} onClick={() => deleteVariant(item?.userVariantMapSeqId)}><DeleteIcon /></span>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )
                        :
                        <div style={{ textAlign: 'center' }}>
                            <p><b>No Variants Available</b></p>
                        </div>
            }
            </div >
    )
};
